export const INCIDENTS_AGE_API_URL = 'ui/organization/stats/incidents_age';
export const incidentsAgeQueryKeys = {
  all: [INCIDENTS_AGE_API_URL, 'incidentsAge'],
};
